<template>
  <div class="renewal-record">
    <search-refund-record
      v-on:resetSearch="resetSearch"
      v-on:onSubmit="onSubmit"
      :payTypeList="renewalPayTypeList"
      :rentStateList="rentStateList"
      :search="search"
      :isRenewal="true"
    >
    </search-refund-record>
    <machine-renewal
      :oldStepsActive="active"
      :process="process"
      :oldState="state"
      :orderNumber="orderNumber"
      :confirmRenew="confirmRenew"
      :renewalList="selectList"
      v-on:cancelRenewal="cancelRenewal"
      :dialogBatchRenewal="dialogBatchRenewal"
    >
    </machine-renewal>
    <confirm-renewal v-on:cancel="cancel" :dialogRenew="dialogRenew" :confirmRenew="confirmRenew"> </confirm-renewal>
    <div class="vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="renewalRecordList"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          prop="userName"
          :label="$t('renewalRecord.userName')"
          :show-overflow-tooltip="true"
          width="200"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="nickName"
          :label="$t('renewalRecord.nickName')"
          width="250"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="payAccount"
          :label="$t('renewalRecord.thirdAccount')"
          :show-overflow-tooltip="true"
          width="200"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="orderNumber"
          :label="$t('renewalRecord.orderNumber')"
          width="170"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="stripeSubscriptionPayType"
          :label="'Renewal Type'"
          :formatter="priceMatter"
          width="140"
          :align="'center'"
        >
          <template slot-scope="scope">
            {{ scope.row.stripeSubscriptionPayType == 1 ? "Monthly" : "Yearly" }}
          </template>
        </el-table-column>
        <el-table-column prop="machine" :label="$t('renewalRecord.machine')" width="150" :align="'center'">
          <template slot-scope="scope">
            <el-popover placement="right-start" trigger="click">
              <el-table :empty-text="$t('common.noData')" :data="scope.row.rentEquipment" style="width: 600px">
                <el-table-column property="name" :label="$t('renewalRecord.equipmentName')"></el-table-column>
                <el-table-column property="equipmentNo" :label="$t('renewalRecord.equipmentNo')"></el-table-column>
                <el-table-column property="date" :label="$t('renewalRecord.expireDate')"></el-table-column>
              </el-table>
              <el-link type="primary" :underline="false" slot="reference"
                >{{ scope.row.rentEquipment && scope.row.rentEquipment.length }}
                {{ $t("renewalRecord.station") }}</el-link
              >
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          :label="$t('renewalRecord.state')"
          :formatter="rentState"
          width="150"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="payType"
          :label="$t('renewalRecord.payType')"
          :formatter="renewalPayType"
          width="100"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
          :label="$t('renewalRecord.createTime')"
          width="160"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.operate')"
          :width="$i18n.locale == 'zh_CN' ? 145 : 225"
          :align="'center'"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.state != '5'">
              <!--							详情-->
              <el-button type="primary" size="mini" v-hasPerm="['renewal:record:update']" @click="nextStep(scope.row)">
                {{ $t("renewalRecord.details") }}
              </el-button>
              <!--							撤销按钮-->
              <el-button
                type="danger"
                size="mini"
                v-hasPerm="['renewal:record:revoke:renew']"
                @click="revoke(scope.row)"
                v-if="scope.row.state == '0'"
              >
                {{ $t("renewalRecord.revoke") }}
              </el-button>
              <!--							确认续费-->
              <el-button
                type="warning"
                size="mini"
                v-hasPerm="['renewal:record:renew']"
                @click="renew(scope.row)"
                v-if="scope.row.state == '1'"
              >
                {{ $t("renewalRecord.renew") }}
              </el-button>
            </template>
            <template v-else>
              <!--							取消-->
              <el-tag size="medium" type="info">{{ $t("renewalRecord.cancelled") }}</el-tag>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import searchRefundRecord from "_c/order/SearchRechargeRecord";
  import machineRenewal from "_c/machine/user/MachineRenewal";
  import confirmRenewal from "_c/order/ConfirmRenewal";
  export default {
    name: "RenewalRecord",
    components: {
      searchRefundRecord,
      machineRenewal,
      confirmRenewal
    },
    data() {
      return {
        loading: false,
        search: {
          equipmentNo: "",
          userName: "",
          orderNumber: "",
          payAccount: "",
          payType: "",
          state: ""
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        renewalRecordList: [],
        rentStateList: [],
        renewalPayTypeList: [],
        dialogBatchRenewal: false,
        active: 0,
        selectList: [],
        orderNumber: "",
        process: "",
        state: "",
        confirmRenew: "",
        dialogRenew: false
      };
    },
    mounted() {
      this.currentChange();
      this.listRenewalStatus();
      this.listRenewalPayType();
    },
    methods: {
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.RenewalRecord.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.renewalRecordList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      listRenewalStatus() {
        this.$api.dict("gp_renewal_status").then(res => {
          if (res.code === 0) {
            this.rentStateList = res.data;
          }
        });
      },
      listRenewalPayType() {
        this.$api.dict("gp_pay_type").then(res => {
          if (res.code === 0) {
            this.renewalPayTypeList = res.data;
          }
        });
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },

      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },

      rentState(row) {
        return this.$cloud.getDictLabel(this.rentStateList, row.state);
      },
      renewalPayType(row) {
        return this.$cloud.getDictLabel(this.renewalPayTypeList, row.payType);
      },

      nextStep(row) {
        this.dialogBatchRenewal = true;
        this.active = parseInt(row.state) >= 2 ? 2 : parseInt(row.state) + 1;
        this.process = parseInt(row.state) >= 2 ? "finish" : "";
        this.state = row.state;
        this.selectList = row.rentEquipment;
        this.orderNumber = row.id;
        this.confirmRenew = row;
      },

      revoke(row) {
        this.$confirm(this.$t("renewalRecord.revokeRenew"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api.request(this.$url.RenewalRecord.revokeRenew, this.$method.put, row).then(res => {
            if (res.code === 0) {
              this.$notify({
                title: this.$t("common.tip"),
                message: res.msg,
                type: "success"
              });
              this.currentChange();
            }
          });
        });
      },

      cancelRenewal(dialog, state) {
        this.dialogBatchRenewal = dialog;
        if (state) {
          this.currentChange();
        }
      },

      renew(row) {
        this.confirmRenew = row;
        this.dialogRenew = true;
      },

      cancel(dialog, state) {
        this.dialogRenew = dialog;
        if (state) {
          this.currentChange();
        }
      }
    }
  };
</script>

<style lang="scss" scoped></style>
